import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { useHistory } from "react-router-dom";

import { useMutation } from "react-apollo";
import { Title, Button, Field, Control } from "rbx";
import moment from "moment";

import { CalendarInput } from "../../../components/inputs";

import { getPickupTime } from "../../../components/Orders/utils";

import {
  BULK_CREATE_ORDER_MUTATION,
  BULK_CREATE_ORDER_DETAIL_MUTATION
} from "../../../graphql/Orders/Orders.graphql";
import {
  saveFilterState,
  getUTCFormattedDate,
  ourToast as toast
} from "../../../utils";
import { useSystemCodes } from "../../../utils/hooks";

const INITIAL_STATE = {
  CustomerRecIdRef: "",
  RouteRecIdRef: "",
  LoadTypeRecIdRef: "",
  StartLocationRecIdRef: "",
  PickupLocationRecIdRef: "",
  DeliveryLocationRecIdRef: "",
  EndingLocationRecIdRef: "",
  Customer_SI: "",
  StartLoc_SI: "",
  PickupLoc_SI: "",
  DeliveryLoc_SI: "",
  EndLoc_SI: "",
  EstimatedLoad: "",
  EstimatedTravel: "",
  EstimatedUload: "",
  OrderDate: "",
  OrderTime: "",
  RequestedDeliveryDate: "",
  RequestedDeliveryTime: "",
  ScheduledDeliveryDate: "",
  ScheduledDeliveryTime: "",
  PickupDate: "",
  PickupTime: "",
  BillToRecIdRef: null,
  PaymentMethodRecIdRef: "",
  CustRef: "",
  CompanyId: "",
  CreatedBy: null,
  OrderedBy: "",
  BookingCodeRecIdRef: "",
  LoadedMiles: "",
  TariffRecIdRef: "",
  BillingNotes: "",
  OrderNotes: "",
  NonBill: false,
  PaymentTermsRecIdRef: ""
};

const NewOrderOptions = ({
  newOrder,
  newOrderDetails,
  onComplete,
  onSubmit,
  onCancel
}) => {
  const history = useHistory();
  const SystemCodes = useSystemCodes({
    Category: "Order",
    CodeName: "OrderStatus",
    CodeId: "U"
  });
  const [data, setData] = useState({
    [moment(newOrder.RequestedDeliveryDate).format("YYYY-MM-DD")]: "1"
  });

  useEffect(() => {
    if (SystemCodes?.data?.length > 0 && !INITIAL_STATE?.StatusRecIdRef) {
      INITIAL_STATE.StatusRecIdRef = SystemCodes.data[0].RecId;
    }
  }, [SystemCodes]);

  const handleChange = state => {
    setData(state);
  };

  const [bulkCreateOrder] = useMutation(BULK_CREATE_ORDER_MUTATION, {
    refetchQueries: ["ALL_ORDERS_QUERY", "ALL_ORDERS_VIEW_QUERY"]
  });
  const [bulkCreateOrderDetail] = useMutation(
    BULK_CREATE_ORDER_DETAIL_MUTATION,
    {
      refetchQueries: ["ALL_ORDER_DETAILS_QUERY"]
    }
  );

  const handleSave = async () => {
    try {
      onSubmit();

      const obj = Object.keys(INITIAL_STATE).reduce(
        (acc, curr) =>
          newOrder[curr] !== null ? { ...acc, [curr]: newOrder[curr] } : acc,
        {}
      );

      const orders = [].concat(
        ...Object.keys(data).map((date, i) => {
          const newOrderDate = moment(date);

          const { month, day, year } = {
            month: newOrderDate.month(),
            day: newOrderDate.date(),
            year: newOrderDate.year()
          };

          const d = moment(newOrder.RequestedDeliveryDate)
            .set("month", month)
            .set("date", day)
            .set("year", year);
          const requested = d.toDate();

          const pickupDate = getPickupTime(
            requested,
            obj.EstimatedLoad,
            obj.EstimatedTravel
          );

          obj.OrderDate = moment(newOrder.OrderDate).toDate();
          obj.RequestedDeliveryDate = requested;
          obj.PickupDate = pickupDate;
          obj.ScheduledDeliveryDate = requested;

          console.log(`--------------- ORDER ${i + 1} ------------------`);
          console.log(`Order Date: ${obj.OrderDate}`);
          console.log(`Requested Delivery Date: ${obj.RequestedDeliveryDate}`);
          console.log(`Pickup Date: ${obj.PickupDate}`);
          console.log(`Scheduled Delivery Date: ${obj.ScheduledDeliveryDate}`);
          console.log(`-------------------------------------------------\n`);

          return Array.from({ length: parseInt(data[date]) }).map(() => ({
            StatusRecIdRef: INITIAL_STATE.StatusRecIdRef,
            OrderDate: getUTCFormattedDate(obj.OrderDate),
            RequestedDeliveryDate: obj.RequestedDeliveryDate,
            PickupDate: obj.PickupDate,
            ScheduledDeliveryDate: obj.ScheduledDeliveryDate,
            CustomerRecIdRef: parseInt(obj.CustomerRecIdRef),
            RouteRecIdRef: parseInt(obj.RouteRecIdRef),
            EstimatedLoad: parseFloat(obj.EstimatedLoad),
            EstimatedTravel: parseFloat(obj.EstimatedTravel),
            EstimatedUnload: parseFloat(obj.EstimatedUload),
            EstimatedUload: parseFloat(obj.EstimatedUload),
            PaymentMethodRecIdRef: parseInt(obj.PaymentMethodRecIdRef),
            StartLoc_SI: obj.StartLoc_SI,
            PickupLoc_SI: obj.PickupLoc_SI,
            DeliveryLoc_SI: obj.DeliveryLoc_SI,
            EndLoc_SI: obj.EndLoc_SI,
            PaymentTermsRecIdRef: obj.PaymentTermsRecIdRef
              ? parseInt(obj.PaymentTermsRecIdRef)
              : null,
            LoadTypeRecIdRef: obj.LoadTypeRecIdRef
              ? parseInt(obj.LoadTypeRecIdRef)
              : null,
            StartLocationRecIdRef: obj.StartLocationRecIdRef
              ? parseInt(obj.StartLocationRecIdRef)
              : null,
            PickupLocationRecIdRef: obj.PickupLocationRecIdRef
              ? parseInt(obj.PickupLocationRecIdRef)
              : null,
            DeliveryLocationRecIdRef: obj.DeliveryLocationRecIdRef
              ? parseInt(obj.DeliveryLocationRecIdRef)
              : null,
            EndingLocationRecIdRef: obj.EndingLocationRecIdRef
              ? parseInt(obj.EndingLocationRecIdRef)
              : null,
            BillToRecIdRef: obj.BillToRecIdRef
              ? parseInt(obj.BillToRecIdRef)
              : null,
            BookingCodeRecIdRef: obj.BookingCodeRecIdRef
              ? parseInt(obj.BookingCodeRecIdRef)
              : null,
            LoadedMiles: obj.LoadedMiles ? parseFloat(obj.LoadedMiles) : null,
            TariffRecIdRef: obj.TariffRecIdRef
              ? parseInt(obj.TariffRecIdRef)
              : null,
            OrderNote: obj.OrderNote,
            BillingNotes: obj.BillingNotes,
            NonBill: !!obj.NonBill
          }));
        })
      );

      const { data: orderData } = await bulkCreateOrder({
        variables: {
          data: orders
        }
      });
      const odList = [].concat(
        ...orderData.bulkCreateOrder.map(o =>
          newOrderDetails.map(od => ({
            ProductRecIdRef: parseInt(od.ProductRecIdRef.value),
            Description: od.Description,
            Quantity: parseInt(od.Quantity),
            TariffRecIdRef: od.TariffRecIdRef,
            Hazmat: od.HazmatCode,
            OrderRecIdRef: o.RecId,
            ProdCatgRecIdRef: od.ProdCatgRecIdRef,
            UOMRecIdRef: od.UOMRecIdRef ? parseInt(od.UOMRecIdRef) : null,
            Rate: od.Rate ? parseFloat(od.Rate) : null,
            InternalComm: od.InternalComm,
            ExternalComm: od.ExternalComm
          }))
        )
      );

      await bulkCreateOrderDetail({
        variables: {
          data: odList
        }
      });

      saveFilterState("ORDER_FILTERS", {
        OrderNumber_in: orderData.bulkCreateOrder.map(x => x.OrderNumber)
      });

      onComplete();

      toast.success("Order created successfully.");
      history.push("/dispatch/orders");
    } catch (err) {
      toast.error("Error creatign Order.");
    }
  };
  return (
    <div className="new-order-options">
      <Title>
        {moment(newOrder.RequestedDeliveryDate).format("ddd MM/DD/YYYY")}
      </Title>
      <Title subtitle>Requested Delivery</Title>
      <CalendarInput
        data={data}
        startDate={moment(newOrder.RequestedDeliveryDate)}
        onChange={handleChange}
      />

      <hr style={{ background: "transparent" }} />
      <Field align="right" kind="group">
        <Control>
          <Button onClick={onCancel}>Cancel</Button>
        </Control>
        <Control>
          <Button color="success" onClick={handleSave}>
            Submit
          </Button>
        </Control>
      </Field>
    </div>
  );
};

NewOrderOptions.propTypes = {
  newOrder: PropTypes.object,
  newOrderDetails: PropTypes.array,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  onComplete: PropTypes.func
};
export default NewOrderOptions;
